import { Component, OnInit, ViewChild, ElementRef, TemplateRef } from '@angular/core';

@Component({
  selector: 'app-video-modal',
  templateUrl: './video-modal.component.html',
  styleUrls: ['./video-modal.component.scss']
})
export class VideoModalComponent implements OnInit {
  @ViewChild('video', {read: ElementRef}) video: ElementRef;

  constructor() { }

  ngOnInit() {
    // console.log(this.video)
  }

}



// WEBPACK FOOTER //
// ./src/app/video-modal/video-modal.component.ts